import { resetStateRTK } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import { LiveDataState } from "../actions/LiveData/types";
import { isDictionaryEmpty } from "../Utilities/generalUtilities";
import { createReducer } from "@reduxjs/toolkit";
import {
    setHaloWidth,
    setLastUpdatedLiveData,
    toggleLiveData,
    updateLiveDataToStore
} from "actions";
import { CityConfigInterface } from "components/curb/map/deckgl/interfaces";

const initialState: LiveDataState = {
    liveDataButtonStatus: false,
    liveData: {},
    lastUpdatedLiveData: {} as CityConfigInterface
};
const liveData = createReducer(initialState, (builder) => {
    builder
        .addCase(toggleLiveData, (state, action) => {
            state.liveDataButtonStatus = action.payload.isLiveDataOn;
        })
        .addCase(setHaloWidth, (state, action) => {
            const { id, width } = action.payload;
            const liveDataclone = JSON.parse(JSON.stringify(state.liveData));
            liveDataclone[id].haloWidth = width;
            state.liveData = liveDataclone;
        })
        .addCase(updateLiveDataToStore, (state, action) => {
            let result = {};

            if (!isDictionaryEmpty(action.payload.data)) {
                result = {
                    ...state.liveData,
                    ...action.payload.data
                };
            }
            state.liveData = result;
        })
        .addCase(setLastUpdatedLiveData, (state, action) => {
            state.lastUpdatedLiveData = action.payload.data;
        })
        .addCase(resetStateRTK, () => initialState)
        .addDefaultCase((state) => state);
});

export default liveData;
